import { Stack } from "@mui/material";
import Grid from '@mui/material/Grid2';
import { useTranslation } from "react-i18next";
import {
  AccountLogo,
  LogoCaptionTypography,
  logoGridCloseStyles,
  logoGridContainerStyles,
  logoGridOpenStyles,
  LogoTitleTypography
} from "./styles";

interface LogoProps {
    isOpen?: boolean;
}

export const Logo = ({ isOpen }: LogoProps) => {
  const { t } = useTranslation();

  return (
    <Grid container sx={logoGridContainerStyles}>
      <Grid
        size={2}
        sx={(isOpen ? logoGridOpenStyles : logoGridCloseStyles)}
      >
        <AccountLogo />
      </Grid>
      {isOpen && (
        <Grid size={10}>
          <Stack>
            <LogoTitleTypography variant="h5">{t('accessAccout')}</LogoTitleTypography>
            <LogoCaptionTypography variant="caption">{t('digitalPlatform')}</LogoCaptionTypography>
          </Stack>
        </Grid>
      )}
    </Grid>
  );
};
export default Logo;
